<mat-dialog-content>
  <div class="row spinner-row">
    <img
      src="/assets/images/logo/logo.png"
      alt="logo"
      class="spinner align-content-center for-light"
    />
    <img
      src="/assets/images/logo/byd-logo.png"
      alt="logo"
      class="spinner align-content-center for-dark"
    />
    <label class="spinner-text" [innerHtml]="spinnerText | translate"></label>
  </div>
</mat-dialog-content>
